import { Editor } from 'roosterjs-editor-core';
import { PluginDomEvent, PluginEvent, PluginEventType } from 'roosterjs-editor-types';

const BACKSPACE_KEYCODE = 8;
const DELETE_KEYCODE = 46;

export default function isLinkRemovalRelatedEvent(evt: PluginEvent, editor: Editor): boolean {
    if (evt.eventType === PluginEventType.ContentChanged) {
        return true;
    }

    if (evt.eventType === PluginEventType.KeyDown) {
        const domEvent: PluginDomEvent = evt as PluginDomEvent;
        const keyboardEvent: KeyboardEvent = domEvent.rawEvent as KeyboardEvent;
        return keyboardEvent.which === BACKSPACE_KEYCODE || keyboardEvent.which === DELETE_KEYCODE;
    }

    if (evt.eventType === PluginEventType.KeyPress) {
        return editor && editor.getSelectionRange() && !editor.getSelectionRange().collapsed;
    }

    return false;
}
